import useEmblaCarousel from "embla-carousel-react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const Testimonials = () => {
  const [emblaRef] = useEmblaCarousel({ align: "start", containScroll: "trimSnaps" });

  return (
    <div data-testid="testimonials">
      <div className="overflow-hidden cursor-grab active:cursor-grabbing" ref={emblaRef}>
        <div className="flex gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="min-w-0 flex-[0_0_85%] sm:flex-[0_0_55%] lg:flex-[0_0_38%]">
              <div className="h-full rounded-sm border border-line bg-white p-8 flex flex-col" data-testid={`testimonial-card-${i}`}>
                <Quote size={20} className="text-pine" aria-hidden="true" />
                <p className="mt-6 text-base leading-relaxed text-dim flex-1">{t.quote}</p>
                <div className="mt-8 pt-6 border-t border-line flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium">{t.name}</p>
                    <p className="text-xs text-tertiary mt-0.5">{t.course}</p>
                  </div>
                  {t.placeholder && (
                    <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-tertiary border border-line rounded-full px-3 py-1">
                      Placeholder
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Reveal>
        <p className="mt-6 text-xs text-tertiary">Drag or swipe to browse · Testimonials shared by T Plus One students.</p>
      </Reveal>
    </div>
  );
};

export default Testimonials;
